import { CloseOutlined } from "@ant-design/icons"
import { Form, FormInstance, FormProps, Input, Modal, Select } from "antd"
import './style.scss'
import { ICarCompany } from "../../../../../api/selectOption/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
import { useEffect, useRef, useState } from "react"
import { ICarLine, ICarLineEdit, editCarLines } from "../../../../../api/carLine/carLineApi"
import useThrottle from "../../../../../hook/useThrottle"
import { useForm } from "antd/lib/form/Form"
interface ModalProps {
  isOpen: boolean
  infoCarLines?: ICarLine
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}
const ModalViewVehicle: React.FC<ModalProps> = ({
  isOpen, infoCarLines,
  closeModal
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    // const result = await editCarLines(Number(infoCarLine?.id), values.typecar, values.codetypecar, values.namebrand)
    // if (result?.status) {
    //   onSubmitFormModal?.(true)

    // } else {
    //   onSubmitFormModal?.(false, result.message)
    // }
  }


  useEffect(() => {
    if (isOpen && infoCarLines) {
      const { code, title } = infoCarLines
      form.setFieldsValue({
        "code": code,
        "title": title,
      })
    } else {
      form.resetFields()
    }

  }, [isOpen])
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Chi tiết dòng xe</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content-vehicle ant-modal-size"
        closeIcon={false}
        footer={false}
      >
        <div className="p-6 d-flex flex-column gap-18-px">
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <div className="d-flex flex-column gap-1">
                <Form.Item
                  label="Mã dòng xe"
                  layout="vertical"
                  name="code"
                  rules={[{ required: true, message: 'Nhập mã dòng xe!' }]}
                  className="m-none-form-item text-explan text-label"
                >
                  <Input
                    placeholder="Mã dòng xe"
                    className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label="Dòng xe"
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập Dòng xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Dòng xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Modal>
    </Form>

  )
}
export default ModalViewVehicle
